import {
  AppUserShow,
  CompaniesList,
  CompanyMember,
  FetchRecord,
  PropertyMangerShow,
  UserList,
  UserShow,
  PartnerList,
  StaffsList,
  UserUnlockRecords,
} from "@admin/pages/users-configure";
import type { RouteObject } from "react-router-dom";

const userList = [
  { index: true, element: <UserList /> },
  { path: ":id", element: <UserShow /> },
  // { path: "app_user/:id", element: <AppUserShow /> },
  // { path: "property_manager/:id", element: <PropertyMangerShow /> },
  // { path: "unlock/:id", element: <UserUnlockRecords /> },
] satisfies RouteObject[];
const partnersList = [
  { index: true, element: <PartnerList /> },
] satisfies RouteObject[];
const staffsList = [{ index: true, element: <StaffsList /> }];
// const companyList = [
// { index: true, element: <CompaniesList /> },
// { path: "member/:id", element: <CompanyMember /> },
// { path: "member_fetch/:id", element: <FetchRecord /> },
// ] satisfies RouteObject[];
export const userListRoute = [
  { path: "/users_list", children: userList },
  { path: "/partners_list", children: partnersList },
  { path: "/staffs_list", children: staffsList },
  // { path: "/companies_list", children: companyList },
] satisfies RouteObject[];
